"use client";
import { jsx as r, Fragment as t } from "react/jsx-runtime";
import { createSvgIcon as e } from "@mui/material/utils";
const n = e(
  /* @__PURE__ */ r(t, { children: /* @__PURE__ */ r(
    "path",
    {
      d: "M9.81999 19.07C9.63999 19.07 9.45999 19 9.31999 18.86C9.03999 18.58 9.03999 18.13 9.31999 17.86L15.18 12L9.31999 6.14001C9.03999 5.86001 9.03999 5.41001 9.31999 5.14001C9.59999 4.87001 10.05 4.86001 10.32 5.14001L16.68 11.5C16.96 11.78 16.96 12.23 16.68 12.5L10.32 18.86C10.18 19 9.99999 19.07 9.81999 19.07Z",
      fill: "currentColor"
    }
  ) }),
  "KmxChevronRightStroked"
);
export {
  n as default
};
